import {GameRandom, Inject, ModelEvents, Singleton} from "@denishussar/html5-game-engine";
import {ElectricityModel} from "../Models/ElectricityModel";
import {SwitchModel, SwitchStateEnum, SYMBOLS} from "../Models/SwitchModel";
import * as _ from "lodash"

@Singleton
export class ElectricityLogic {
    private codeInSwitches: string[] = new Array<string>();

    constructor(@Inject private _model: ElectricityModel,
                @Inject private _modelEvents: ModelEvents,
                @Inject private _random: GameRandom) {

    }

    public reset(): void {
        this.codeInSwitches = [];

        this._model.switches = [];
        this._model.code = _.shuffle(SYMBOLS);

        for (let i = 0; i < SYMBOLS.length; i++) {
            this._model.switches[i] = new SwitchModel(SYMBOLS[i], i);
        }
    }

    public clickOnSwitch(model: SwitchModel): void {

        model.state =
            (model.state === SwitchStateEnum.off || model.state === SwitchStateEnum.off_immediately)
            && SwitchStateEnum.on || SwitchStateEnum.off_immediately;

        !_.includes(this.codeInSwitches, model.value) && this.codeInSwitches.push(model.value);

        if (_.some(this._model.switches, s => s.state === 0 || s.state === -1)) {
            return;
        }

        if (this.codeInSwitches.join() === this._model.code.join()) {

            this._modelEvents.dispatch(this._model, "win");
            _.each(this._model.switches, s => s.state = SwitchStateEnum.disable);

        } else if (this.codeInSwitches.length === 4) {

            this._modelEvents.dispatch(this._model, "fail");

            _.each(this._model.switches, s => s.state = SwitchStateEnum.off);

        }

        this.codeInSwitches.length === 4 && this.codeInSwitches.splice(0);

    }

}
